import React from 'react';
import VoxelPanel from '../../../components/voxel/Surfaces/VoxelPanel';
import VoxelTable from '../../../components/voxel/Tables/VoxelTable';
import VoxelTableCell from '../../../components/voxel/Tables/VoxelTableCell';
import VoxelTableRow from '../../../components/voxel/Tables/VoxelTableRow';
import VoxelText from '../../../components/voxel/Text/VoxelText';
import VoxelDivider from '../../../components/voxel/VoxelDivider';
import { CurrentTeamGq } from '../../../graphql/users/models/CurrentTeamGq';
import { formatNumber } from '../../../logic/otherUtilities/formatting/formatNumber';

export interface CapacityProps {
  team: CurrentTeamGq;
  licenses: number;
}

export const Capacity: React.FC<CapacityProps> = ({ team, licenses }) => {
  return (
    <VoxelPanel className="flex flex-col">
      <VoxelDivider />
      <VoxelText className="px-6 py-4" color="slight" variant="title3">
        Capacity
      </VoxelText>
      <VoxelTable className="table-fixed">
        <colgroup>
          <col className="w-24" />
          <col />
        </colgroup>
        <tbody>
          <VoxelTableRow>
            <VoxelTableCell className="px-6">Unlimited</VoxelTableCell>
            <VoxelTableCell className="pl-6">Users</VoxelTableCell>
          </VoxelTableRow>

          <VoxelTableRow>
            <VoxelTableCell className="px-6">
              {formatNumber(licenses * team.appTier.includedTeams)}
            </VoxelTableCell>
            <VoxelTableCell className="pl-6">Team connections</VoxelTableCell>
          </VoxelTableRow>

          <VoxelTableRow>
            <VoxelTableCell className="px-6">
              {formatNumber(licenses * team.appTier.monthlyCapSearchVolumeKw)}
            </VoxelTableCell>
            <VoxelTableCell className="pl-6">Google search keywords</VoxelTableCell>
          </VoxelTableRow>

          <VoxelTableRow>
            <VoxelTableCell className="px-6">
              {formatNumber(licenses * team.appTier.monthlyCapRankKw)}
            </VoxelTableCell>
            <VoxelTableCell className="pl-6">Rank keywords</VoxelTableCell>
          </VoxelTableRow>

          <VoxelTableRow>
            <VoxelTableCell className="px-6">
              {formatNumber(licenses * team.appTier.monthlyCapTranslateKw)}
            </VoxelTableCell>
            <VoxelTableCell className="pl-6">Translate keywords</VoxelTableCell>
          </VoxelTableRow>

          <VoxelTableRow>
            <VoxelTableCell className="px-6">
              {formatNumber(licenses * team.appTier.monthlyCapChatGptDrafts)}
            </VoxelTableCell>
            <VoxelTableCell className="px-6">ChatGPT drafts</VoxelTableCell>
          </VoxelTableRow>
        </tbody>
      </VoxelTable>
    </VoxelPanel>
  );
};

export default Capacity;
